module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentRoute == 'login' || _vm.currentRoute == 'logout') ? _c('Login') : _vm._e(), _vm._v(" "), (_vm.currentRoute == 'reset-password') ? _c('ResetPassword') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c36abd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/Public.vue
// module id = 162
// module chunks = 1